<template>
    <div>
        <button class="btn btn-green" @click="trigger" v-if="canBeOrdered" :disabled="quantity < 1 || !canBeOrdered || processing">
            <i class="fa fa-refresh fa-spin" v-if="processing"></i>
            <slot v-if="quantity > 0"></slot>
            <span v-else>Please enter a quantity</span>
        </button>

        <button class="btn btn-red" v-else disabled>Out of stock!</button>

        <template v-if="errors.length != 0">
            <ul class="form-errors">
                <template v-for="errors in errors">
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </template>
            </ul>
        </template>

        <modal-dialog title="Delivery or Collect?" classes="modal--centered" :show="showModal" @close="showModal = false">
            <div class="text-center">
                <p>Have your order delivered<br> <em>or</em> you can collect from our <a href="/trade-counter" target="_blank">Watford Trade Counter</a>.</p>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <button class="btn btn-sm btn-blue" @click="add(true)">Click &amp; Collect</button>
                </div>
                <div class="col-md-6 text-right">
                    <button class="btn btn-sm btn-green" @click="add(false)">Deliver</button>
                </div>
            </div>
        </modal-dialog>
    </div>
</template>

<script>
    import Basket from '../../Services/Basket.js';
    import ModalDialog from '../Elements/ModalDialog.vue';
    import Notification from '../../Services/Notification.js';
    import Session from '../../Services/Session.js';

    export default {
        components: {
           ModalDialog,
        },
        props: ['id', 'quantity', 'name', 'stock', 'incoming', 'backorder', 'shipping'],
        data() {
            return {
                service: Basket,
                errors: [],
                processing: false,
                showModal: false
            }
        },
        computed: {
            canBeOrdered() {
                if (
                    this.backorder == 'always' ||
                    this.backorder == 'expected' && (this.incoming + this.stock) > 0
                ) {
                    return true;
                }
                return this.stock >= 1;
            }
        },
        mounted() {
            if (getCookie('delivery_preference')) {
                this.service.setPreference(getCookie('delivery_preference'));
            }
        },
        methods: {
            add(collect) {
                this.processing = true;
                this.errors = [];
                this.showModal = false;

                if (!this.service.preference) {
                    let preference = collect ? 'collection' : 'delivery';
                    this.service.setPreference(preference);
                    createCookie('delivery_preference', preference, 1440, '/'); // Remember for a day
                }

                let meta = null;

                if (this.quantity > this.stock) {
                    meta = {
                        backorder: this.quantity > this.stock,
                    }
                }

                this.service.add(this.id, this.quantity, meta)
                .then(response => {
                    this.processing = false;
                    const message = this.quantity + ' x ' + this.name + ' added to your basket';
                    this.$notify({
                        text: message,
                        group: 'basket',
                        type: 'success'
                    });
                    this.$emit('success', response.data);
                })
                .catch(response => {
                    this.errors = this.service.errors;
                    this.processing = false;
                    this.$emit('error', this.errors);
                });

            },
            trigger() {
                if (!this.service.preference) {
                    this.showModal = true;
                } else {
                    this.add();
                }
            }
        }
    }
</script>

<style scoped>
    button {
        width:100%;
    }
    .form-errors {
        list-style:none;
        padding:0;
        margin:0;
        margin-top:10px;
    }
    .form-errors li {
        color: #e41d1d;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/AddToBasket.vue